declare namespace $ {

	type $shm_hitalama_textbook_text_header__minimal_height_shm_hitalama_textbook_text_1 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_hitalama_textbook_text_header['minimal_height'] >
	>
	type $shm_hitalama_textbook_text_header__level_shm_hitalama_textbook_text_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textbook_text['header_level'] >
		,
		ReturnType< $shm_hitalama_textbook_text_header['level'] >
	>
	type $shm_hitalama_textbook_text_header__content_shm_hitalama_textbook_text_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textbook_text['block_content'] >
		,
		ReturnType< $shm_hitalama_textbook_text_header['content'] >
	>
	type $shm_hitalama_textbook_text_header__arg_shm_hitalama_textbook_text_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textbook_text['header_arg'] >
		,
		ReturnType< $shm_hitalama_textbook_text_header['arg'] >
	>
	export class $shm_hitalama_textbook_text extends $shm_hitalama_text {
		Header( id: any): $shm_hitalama_textbook_text_header
	}
	
	export class $shm_hitalama_textbook_text_header extends $mol_text_header {
	}
	
}

//# sourceMappingURL=text.view.tree.d.ts.map